import {
  Navigate
} from "react-router-dom";
import { useLoaderData } from "react-router-dom";

export async function inviteLoader({ params }) {
  const { invitationCode } = params;
  return { invitationCode };
}

export default function Invite() {
  const { invitationCode } = useLoaderData();
  return <Navigate to={{ pathname: "/home", search: `?invitationCode=${invitationCode}` }} replace/>;
}

